export default {
  title: '门店详情', // 拓店标准版-门店管理
  url: '/expandstore/shopDetail' // 埋点用，记录所属模块
};
